import React from 'react';

export function NotFound({ onHomeClick }) {
  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundColor: '#f7f5f3',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 20px',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      {/* Organic blob shapes */}
      <div
        style={{
          position: 'absolute',
          top: '15%',
          left: '-8%',
          width: '400px',
          height: '400px',
          borderRadius: '60% 40% 30% 70% / 60% 30% 70% 40%',
          background: 'rgba(241, 91, 65, 0.06)',
          filter: 'blur(60px)',
          pointerEvents: 'none'
        }}
      />
      <div
        style={{
          position: 'absolute',
          bottom: '10%',
          right: '-10%',
          width: '500px',
          height: '500px',
          borderRadius: '40% 60% 70% 30% / 40% 50% 60% 50%',
          background: 'rgba(129, 156, 209, 0.06)',
          filter: 'blur(60px)',
          pointerEvents: 'none'
        }}
      />

      {/* Wavy top decoration */}
      <svg
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '120px',
          pointerEvents: 'none'
        }}
        viewBox="0 0 1440 120"
        preserveAspectRatio="none"
      >
        <path
          d="M0,80 C200,40 400,100 600,60 C800,20 1000,80 1200,50 C1320,30 1380,60 1440,40 L1440,0 L0,0 Z"
          fill="rgba(241, 91, 65, 0.08)"
        />
      </svg>

      {/* Wavy bottom decoration */}
      <svg
        style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          height: '100px',
          pointerEvents: 'none'
        }}
        viewBox="0 0 1440 100"
        preserveAspectRatio="none"
      >
        <path
          d="M0,30 C300,70 500,20 720,50 C940,80 1200,30 1440,60 L1440,100 L0,100 Z"
          fill="rgba(39, 39, 38, 0.04)"
        />
      </svg>

      {/* Main Content */}
      <div
        style={{
          textAlign: 'center',
          maxWidth: '600px',
          position: 'relative',
          zIndex: 1
        }}
      >
        {/* Puppet Image */}
        <div
          style={{
            marginBottom: '24px',
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          <img
            src="/Grimace_blonde_puppet.png"
            alt="Oops!"
            style={{
              width: '180px',
              height: 'auto',
              filter: 'drop-shadow(0 8px 24px rgba(0,0,0,0.1))'
            }}
          />
        </div>

        {/* 404 Number */}
        <h1
          style={{
            fontFamily: '"Source Serif Pro", Georgia, serif',
            fontSize: 'clamp(80px, 15vw, 140px)',
            fontWeight: '700',
            color: '#272726',
            margin: '0',
            lineHeight: '1',
            letterSpacing: '-4px'
          }}
        >
          404
        </h1>

        {/* Main Message */}
        <h2
          style={{
            fontFamily: '"Source Serif Pro", Georgia, serif',
            fontSize: 'clamp(24px, 4vw, 32px)',
            fontWeight: '700',
            color: '#272726',
            margin: '16px 0 12px 0',
            lineHeight: '1.2'
          }}
        >
          Page Not Found
        </h2>

        {/* Empathetic Subtext */}
        <p
          style={{
            fontSize: '18px',
            color: '#666',
            margin: '0 0 8px 0',
            lineHeight: '1.6'
          }}
        >
          We know how frustrating it is when things don't go as planned.
        </p>
        <p
          style={{
            fontSize: '16px',
            color: '#999',
            margin: '0 0 32px 0',
            lineHeight: '1.5'
          }}
        >
          Let's get you back on track.
        </p>

        {/* CTA Buttons */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            alignItems: 'center'
          }}
        >
          <button
            onClick={onHomeClick}
            style={{
              padding: '16px 48px',
              fontSize: '16px',
              fontWeight: '700',
              color: '#272726',
              backgroundColor: '#fff1b2',
              border: '2px solid #272726',
              borderRadius: '30px',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              textTransform: 'uppercase',
              letterSpacing: '1px'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-3px)';
              e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.15)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            Return to Homepage
          </button>

          <a
            href="mailto:hello@realpatients.com"
            style={{
              fontSize: '14px',
              color: '#666',
              textDecoration: 'none',
              marginTop: '8px'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = '#f15b41';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = '#666';
            }}
          >
            Or contact us if you need help
          </a>
        </div>

        {/* Fun Easter Egg Text */}
        <p
          style={{
            fontSize: '13px',
            color: '#bbb',
            marginTop: '48px',
            fontStyle: 'italic'
          }}
        >
          Even she's not sure how you ended up here.
        </p>
      </div>
    </div>
  );
}

export default NotFound;
